import { HttpLink } from '@apollo/client/core';
import { endpoints } from '@/config';
const uri = endpoints.graphql;
const httpLink = new HttpLink({ uri, credentials: 'omit' });
export default httpLink;
